import { Zap } from "lucide-react";

const items = [
    "AI Pipeline Automation",
    "CRM Optimization",
    "Predictive Revenue Analytics",
    "Canadian Enterprise Sales",
    "24/7 Lead Qualification",
    "4.8x Conversion Lift",
];

export default function Marquee() {
    const row = [...items, ...items];
    return (
        <div
            data-testid="editorial-marquee"
            className="bg-[#0E121B] py-6 border-y border-white/10 overflow-hidden"
            aria-hidden="true"
        >
            <div className="animate-marquee flex w-max items-center">
                {row.map((item, i) => (
                    <span
                        key={i}
                        className="flex items-center gap-8 pr-8 font-mono-tech text-sm tracking-[0.25em] uppercase text-slate-400 whitespace-nowrap"
                    >
                        {item}
                        <Zap className="w-3.5 h-3.5 text-[#FF3B30]" />
                    </span>
                ))}
            </div>
        </div>
    );
}
